export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0-3h16v16H0z\"/><path d=\"M14.786 0H1.214C.544 0 0 .499 0 1.113v8.274c0 .614.544 1.113 1.214 1.113h13.572c.67 0 1.214-.499 1.214-1.113V1.113C16 .499 15.456 0 14.786 0zM10 1v8.5H6V1h4zM1 9.387V1.113C1 1.074 1.083 1 1.214 1H5v8.5H1.215C1.083 9.5 1 9.426 1 9.387zm14 0c0 .039-.084.113-.214.113H11V1h3.786c.13 0 .214.074.214.113v8.274z\" fill=\"#3F4450\" fill-rule=\"nonzero\"/></g>",
  "attrs": {
    "width": "16",
    "height": "11",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};